import type { CustomFile } from '../types';

import { DEFAULT_CHUNK_SIZE } from './chunkConstants';

// ----------------------------------------------------------------------------

export function prepareChunkedFile(file: CustomFile, chunkSize: number = DEFAULT_CHUNK_SIZE): Blob[] {
    if (!file || file.size <= 0) {
        return [];
    }

    if (!Number.isFinite(chunkSize) || chunkSize <= 0) {
        throw new Error('chunkSize must be greater than 0.');
    }

    const chunks: Blob[] = [];
    const totalChunks = Math.ceil(file.size / chunkSize);

    for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        chunks.push(chunk);
    }

    return chunks;
}

// ----------------------------------------------------------------------------

export default prepareChunkedFile;
